import { shippingConfig } from '../../config/shipping';
import { discountConfig } from '../../config/discounts';

/**
 * Calculate shipping price including Slovakia extra if applicable
 * @param {number} subTotal - Order subtotal (discounted price)
 * @param {number} basePrice - Base shipping price
 * @param {number} slovakiaExtra - Slovakia extra price
 * @param {string} country - Customer country ('cz' or 'sk')
 * @returns {number} - Final shipping price
 */
const calculateShippingPrice = (subTotal, basePrice, slovakiaExtra = 0, country = 'cz') => {
  // Free shipping for everything deal
  if (discountConfig.freeShippingForEverything) {
    return 0;
  }
  // Free shipping for orders at or above the threshold (discounted price)
  if (subTotal >= shippingConfig.freeShippingThreshold) {
    return 0;
  }
  
  // Add Slovakia extra if customer is from Slovakia
  if (country === 'sk' && slovakiaExtra > 0) {
    return basePrice + slovakiaExtra;
  }
  
  return basePrice;
};

export default calculateShippingPrice; 